import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'
import React from 'react'
import { Translation } from '@morningtrain/react-translations'

function TruncatedList ({ name, max, keyName }) {
  /** @var {any[]} value */
  const value = useValue(name, null)
  if (value == null) {
    return null
  }
  return (
    <div>
      {value.slice(0, max).map((a, i, arr) => (
        <span key={i}>{a[keyName]}{i !== arr.length - 1 ? ', ' : null}</span>
      ))}
      {value.length > max ? <Translation name='generic.truncated' data={{ entry: value.length - max }} /> : null}
    </div>
  )
}

export default observer(TruncatedList)
